import React from 'react';
import { store, useAppSelector } from '@/app/store';
import type { WebSocketConnectionStatus, PendingNotification, SpeedTestState, SubscriptionTarget } from './types';

export function useWebSocketStatus(): WebSocketConnectionStatus {
  return useAppSelector((state) => state.websocket.status);
}

export function usePendingChanges(): PendingNotification[] {
  return useAppSelector((state) => state.websocket.pendingChanges);
}

export function useSpeedTest(): SpeedTestState {
  return useAppSelector((state) => state.websocket.speedTest);
}

/**
 * Subscribe to specific WebSocket event types for the current page.
 * Unsubscribes automatically on unmount or when targets change.
 * Each page should call this with ONLY the types relevant to that page.
 */
export function usePageSubscription(targets: SubscriptionTarget[]): void {
  const serialized = JSON.stringify(targets);

  React.useEffect(() => {
    if (targets.length === 0) return;

    console.log('usePageSubscription: subscribing to', serialized);
    store.subscribeTo(targets);

    return () => {
      console.log('usePageSubscription: unsubscribing');
      store.unsubscribeAll();
    };
  }, [serialized]);
}
